import equalHeight from "./equalHeight";
import "../libraries/lightgallery-all.min";
import 'owl.carousel';
import { CartProductsActivation } from "./cart/components/cart";
import ActivateTabFunc from "./tabPanel/components/activateTabFunc";
import searchFocus from "./header/components/searchFocus";
import SendTipAFriend from "./sendTipaAfriend";
import "../libraries/jquery.scrollTo.min";
import { DataLayerService } from "./dataLayerServices/dataLayerService";
import { GoogleUaEvent } from "./dataLayerServices/googleUaEvent";
import initSelectForTabs from "./tabPanel/components/initSelectForTabs";

export default function productJS() {
  equalHeight();
  $(function () {
    if ($(".product-page").length == 0) {
      return;
    }

    InitImageGallery();
    InitProductComment();
    initSelectForTabs(LoadComments)
    addTextAreaCharCounter(250);

    var initialReviews = $("#ulReviews").clone();
    $('#product .tabs-nav .tab3').on('click', function () {
      LoadComments();
    });
  
    $("#LastRecension").on('click', function () {
      LoadComments();
      ActivateTabFunc($('.tab3'));
    });

    $('.lager-status-func').on('click', function () {
      openLagerstatus();
    });

    $('.toggle-wishlist-func').on('click', function () {
      toggleWishListForm();
    });

    $(".toggle-tip-func").on('click', function () {
      toggleTipsForm();
    });

    $(".view-all-genres-func").on('click', function () {
      viewAllGenres();
    })

    $(window).on('click', function(e) {
      let target = e.target;
      var targetParent = $(target).parent();
      if($(target).hasClass("send-tipa-frend-func")) {
        SendTipAFriend($(target).attr("data-friend"));
      }
      if($(target).attr('id') === 'lnkbReview') {
        SendProductComment($(target).attr('data-identifier'));
      }
    })
    
    function GetCommentsCount(productId){
      const lastRecensionContainer = $("#LastRecensionContainer");
      const lastRecensionHref = $("#LastRecension");
      if (productId) {
        $.ajax({
          url: "/api/ProductComments/getCount/" + productId,
          async: true,
          type: "GET",
          contentType: "application/json",
          success: function (data) {
            if (data > 0) {
              lastRecensionContainer.css('display', 'block');
              lastRecensionHref.text('Läs recensioner (' + data + ')');
            }
          }
        });
      }
    }
    
    function LoadComments() {
      var id = $div.data('productid');
      if (id) {
        $.ajax({
          url: "/api/ProductComments/" + id,
          async: true,
          type: "GET",
          contentType: "application/json",
          success: function (data) {
            var $ulReviews = $("#ulReviews");
            ClearRecensions();
  
            var template = $.templates('#allReviewsTemplate');
            var outerHtml = template.render(data);
            $ulReviews.append(outerHtml);
  
            $(".reviewsTab").addClass('display-inline-block');
  
            $(".rating img").on("mouseover", function () {
              var p = $(this).parent();
              var newRating = $(this).index() + 1;
              setRating(p, newRating);
            });
  
            $(".rating img").on("mouseout", function () {
              var p = $(this).parent();
              var rating = $(p).data("rating");
              setRating(p, rating);
            });
          },
          error: function () {
            $(document).find(".reviewsTab").each(function () {
              $(this).remove();
            });
          }
        });
      }
    }
  
    $('#product .tabs-nav .tab2, #product .tabs-nav .tab1').on('click', function () {
      ClearRecensions();
    });
  
    function ClearRecensions() {
      var $ulReviews = $("#ulReviews");
      $ulReviews.empty();
      $ulReviews.append(initialReviews);
    }
  
    var $div = $("[id$=divMainProductDetails]");
  
    var prodIdentifier = $div.data('productidentifier');
    
    if (typeof (prodIdentifier) != 'undefined' && prodIdentifier != null) {
      GetGinzaRecommendations(prodIdentifier);
  
      getProdInfo(prodIdentifier);
      
      GetCommentsCount(prodIdentifier);
      
      var linkHtml = '<a class="billigast-image disable-link"><img src="https://instore.prisjakt.nu/cheapest.php?id=' + prodIdentifier + '&f=165&small=1"></a>';
      $('.product-gallery .product-block .img-area').prepend(linkHtml);
    }
      
    // Find all YouTube videos
    var $allVideos = $("iframe[src^='//www.youtube.com']"),
  
      // The element that is fluid width
    $fluidEl = $("body");
  
    // Figure out and save aspect ratio for each video
    $allVideos.each(function () {
      $(this)
        .data('aspectRatio', this.height / this.width)
  
        // and remove the hard coded width/height
        .removeAttr('height')
        .removeAttr('width');
  
    });
  
    // When the window is resized
    $(window).resize(function () {
      if ($("input").is(":focus")) {
        return;
      }
      var newWidth = $fluidEl.width();
  
      // Resize all videos according to their own aspect ratio
      $allVideos.each(function () {
  
        var $el = $(this);
        $el
          .width(newWidth)
          .height(newWidth * $el.data('aspectRatio'));
      });
  
      // Kick off one resize to fix all videos on page load
    }).resize();
  });
    
  function zoomBtn() {
    var currentItem = $('.lg-outer').find('.lg-current');
    if (currentItem.find('.lg-img-wrap').length) {
      $('#lg-zoom-in, #lg-zoom-out').css('display', 'block');
    } else {
      $('#lg-zoom-in, #lg-zoom-out').css('display', 'none');
    }
  }
  
  function InitImageGallery() {
    var $slider = $('#slider');
    var thumbnailSlider = $('#thumbnailSlider');
    var duration = 100;
  
    $slider.lightGallery({
      thumbnail: true,
      width: '956px',
      height: '750px',
      mode: 'lg-fade',
      addClass: 'fixed-size',
      counter: false,
      download: false,
      startClass: '',
      enableSwipe: false,
      enableDrag: false,
      hideBarsDelay: 600000,
      zoom: true,
      scale: 4,
      speed: 500,
      thumbContHeight: 50,
      thumbWidth: 70,
      toogleThumb: false,
      loadYoutubeThumbnail: true,
      youtubeThumbSize: 'default',
      youtubePlayerParams: {
      modestbranding: 0,
      showinfo: 1,
      controls: 1
      }
    });
    
    $slider.on('onCloseAfter.lg', function () {
      searchFocus();
    });
    
    $slider.on('onSlideItemLoad.lg', function () {
      zoomBtn();
    });
    
    $slider.on('onAfterSlide.lg', function () {
      zoomBtn();
    });
  
    $slider.on('onAfterOpen.lg', function (event) {
      var thumbnailParent = $('.lg-thumb-item').closest('.lg-thumb');
      
      var videoSrc = $(thumbnailParent.find('img[src*="youtube"]'));
      videoSrc.parent().addClass("video");
      if (typeof (ga) != 'undefined') {
        if ($("#slider .owl-item.active .item").hasClass("video")) {
          ga('send', 'event', 'product-page', 'Product page images gallery click', "product-page-click", "play video");
        }
        else {
          ga('send', 'event', 'product-page', 'Product page images gallery click', "product-page-click", "large image");
        }
      }
      
      let googleUaEvent = new GoogleUaEvent('CustomerActionEvent');
      
      if ($("#slider .owl-item.active .item").hasClass("video")) {
        googleUaEvent.setPayload('product-page', 'Product page images gallery click', "product-page-click", "play video");
      }
      else {
        googleUaEvent.setPayload('product-page', 'Product page images gallery click', "product-page-click", "large image");
      }
      
      const dataLayerService = new DataLayerService();
  
      dataLayerService.triggerUaEvent(googleUaEvent);
    });
  
    $slider.owlCarousel({
      loop: false,
      nav: true,
      items: 1,
      dots: false,
  
      onInitialized: function (event) {
        var carousel = event.target;
        var videoSrc = $(carousel).find('.owl-item a[href*="youtube"]');
        videoSrc.addClass('video');
        videoSrc.removeClass('lazy');
        equalHeight('.owl-item a');
      }
    }).on('changed.owl.carousel', function (e) {
      thumbnailSlider.trigger('to.owl.carousel', [e.item.index, duration, true]);
      $(thumbnailSlider).find('.owl-item').removeClass('current');
      $(thumbnailSlider).find('.owl-item').eq(e.item.index).addClass('current');
    });

    $($slider).find('.owl-prev').attr('role','button');
    $($slider).find('.owl-next').attr('role','button');

    thumbnailSlider.owlCarousel({
      loop: false,
      margin: 4,
      autoWidth: true,
      addClassActive: true,
      nav: true,
      dots: false,
  
      onInitialized: function (event) {
        var carousel = event.target;
        var carouselItems = $(carousel).find('.owl-item');
        carouselItems.first().addClass('current');
  
        var $sliderItems = $('#slider .owl-item');
        $sliderItems.each(function (index, el) {
          if (!$(el).find('.video').length) {
          return;
          }
          $(carouselItems[index]).find('.item').addClass('video');
        });
      }
    });
  
    thumbnailSlider.on('click', '.owl-item', function () {
        // On click of thumbnail items to trigger same main item
        $slider.trigger('to.owl.carousel', [$(this).index(), duration, true]);
    });
    
    thumbnailSlider.on('changed.owl.carousel', function (e) {
        // On change of thumbnail item to trigger main item
        $slider.trigger('to.owl.carousel', [e.item.index, duration, true]);
    });
  }
  
  function toggleTipsForm() {
    $('#tipsForm').toggle();
    return false;
  }
  var isLoadedWishList = false;
  function toggleWishListForm() {
    $('#wishListForm').toggle();
    if (!isLoadedWishList) {
      isLoadedWishList = true;
      InitAddToWishlist();
    }
    return false;
  }
  
  function InitProductComment() {
    $("#review-form").detach().appendTo("body");
  }
  
  function InitAddToWishlist() {
    if ($("#wishListForm>div>span.red").length) {
      return;
    }
    $.ajax({
      url: "/api/CustomersWishlist/GetWishlists",
      cache: false,
      dataType: "json",
      success: function (data) {
        var template = $.templates('#copyToWishlistTemplate');
        var outerHtml = template.render(data);
        $("#wishListForm").append(outerHtml);
      }
    });
  }
  
  
  function getProdInfo(id) {
    $.ajax({
        url: "/Product?handler=ProductInfo&id=" + id,
        success: function (data) {
          if (data != null && data.status != 'error') {
            if (data.showArrows == "1") {
              var links = $("#prod-nav");
      
              if (typeof (data.prevLink) != 'undefined' && data.prevLink != '') {
                links.children('.prev').attr('href', data.prevLink).attr('title', "Föregående produkt");
              }
      
              if (typeof (data.nextLink) != 'undefined' && data.nextLink != '') {
                links.children('.next').attr('href', data.nextLink).attr('title', "Nästa produkt");
              }
      
              links.fadeIn();
            }
          }
        }
    });
  }
  
  function GetGinzaRecommendations(productIdentifier) {
    $.ajax({
      url: "/api/Apptus/Recommendations/" + productIdentifier,
      success: function (data) {
        if (data != null) {
          if (typeof (data.Products) !== 'undefined' && data.Products.length) {
            $('.recommend, .rekommendationer').fadeIn('fast').addClass(data.SectionCssClass);
            var template = $.templates('#haveBoughtTemplate');
            var outerHtml = template.render(data.Products);
            $("#ginzaRecommend").append(outerHtml);
          }
          else {
            $(".ginza-recommendations").hide();
          }
          CartProductsActivation();
        }
        else {
          $(".ginza-recommendations").hide();
        }
      }
    });
  }
  
  function SendProductComment(productIdentifier) {
    var parent = $("#review-form");
    var title = parent.find("#tbxTopic");
    var text = parent.find("#tbxComment");
    var messageLabel = parent.find("#lblResult");
    title.removeClass("error");
    text.removeClass("error");
    messageLabel.html("");
    if (title.val().length == 0) {
      title.addClass("error");
      return;
    }
    if (text.val().length == 0) {
      text.addClass("error");
      return;
    }
    var obj = {};
    obj.title = title.val();
    obj.text = text.val();
    obj.rate = parent.find("ul.star-rating").data("rating");
    obj.productIdentifier = productIdentifier;
    $.ajax({
      type: "POST",
      url: "/api/ProductComments",
      data: JSON.stringify(obj),
      contentType: "application/json",
      beforeSend: function(xhr) {
        parent.find("#lnkbReview").addClass("show-loader");
        xhr.setRequestHeader("XSRF-TOKEN",
            $('input:hidden[name="__RequestVerificationToken"]').val());
      },
      complete: function () { parent.find("#lnkbReview").removeClass("show-loader") },
      success: function (data) {
        if (data && data.Message) {
          if (data.Message.length > 0) {
          messageLabel.html(data.Message);
          }
          if (data.IsSuccess) {
          messageLabel.addClass("success");
          messageLabel.removeClass("error");
          }
        }
      }
    });
  }
  
  function viewAllGenres() {
    window.location.href = $('.sidebar .block-filter-holder:first a').prop('href');
  }
  
  function openLagerstatus() {
    if ($(".func-tabs-nav select").is(":visible")) {
        $(".func-tabs-nav select option").eq(1).prop('selected', "selected");
        ActivateTabFunc($(".func-tabs-nav select option").eq(1));
    }
    else {
        ActivateTabFunc($(".leveransinfoTab"));
    }
    $.scrollTo($(".slide-block"), 500);
  }
  
  function addTextAreaCharCounter(maxLength = 250) {
    const $textarea = $("#tbxComment");
    const $charCount = $(".char-count-func");

    if (!$textarea.length || !$charCount.length) return;

    $textarea.on("input", function () {
      const length = $(this).val().length;
      $charCount.text(`${length} / ${maxLength}`);

      if (length == maxLength) {
        $charCount.addClass("red");
      } else {
        $charCount.removeClass("red");
      }
    });
  }

}
